/**
 * 에러 패턴 모듈
 * 각 카테고리별로 파일을 분리하여 관리합니다.
 */

export { NETWORK_ERROR_PATTERNS } from './network';
export { PHASER_ERROR_PATTERNS } from './phaser';
export { WEBRTC_ERROR_PATTERNS } from './webrtc';
export {
  BROWSER_PLUGIN_ERROR_PATTERNS,
  MOBILE_BROWSER_ERROR_PATTERNS,
  WHALE_BROWSER_ERROR_PATTERNS,
  INDEXEDDB_ERROR_PATTERNS,
  BROWSER_ENGINE_ERROR_PATTERNS,
  THIRD_PARTY_SDK_ERROR_PATTERNS,
  USER_ACTION_ERROR_PATTERNS,
  WEBVIEW_ERROR_PATTERNS,
} from './browser';
export { NEXTJS_ERROR_PATTERNS } from './nextjs';

// Re-export for convenience
import {
  BROWSER_ENGINE_ERROR_PATTERNS,
  BROWSER_PLUGIN_ERROR_PATTERNS,
  MOBILE_BROWSER_ERROR_PATTERNS,
  THIRD_PARTY_SDK_ERROR_PATTERNS,
  USER_ACTION_ERROR_PATTERNS,
  WEBVIEW_ERROR_PATTERNS,
} from './browser';
import { NETWORK_ERROR_PATTERNS } from './network';
import { NEXTJS_ERROR_PATTERNS } from './nextjs';

/**
 * 모든 기본 에러 패턴 (앱 공통)
 * 대부분의 앱에서 사용할 기본 패턴들입니다.
 */
export const CORE_ERROR_PATTERNS = [
  ...NETWORK_ERROR_PATTERNS,
  ...BROWSER_PLUGIN_ERROR_PATTERNS,
  ...MOBILE_BROWSER_ERROR_PATTERNS,
  ...BROWSER_ENGINE_ERROR_PATTERNS,
  ...NEXTJS_ERROR_PATTERNS,
  ...THIRD_PARTY_SDK_ERROR_PATTERNS,
  ...USER_ACTION_ERROR_PATTERNS,
  ...WEBVIEW_ERROR_PATTERNS,
] as const;

/**
 * 에러 체크 함수 타입
 */
export type ErrorCheckFn = (error: unknown) => boolean;

/**
 * 에러 패턴 타입
 * - string: 에러 메시지에 포함된 문자열 검사
 * - RegExp: 에러 메시지에 대한 정규식 검사
 * - ErrorCheckFn: 커스텀 에러 검사 함수
 */
export type ErrorPattern = string | RegExp | ErrorCheckFn;
